<app-menu></app-menu>

<div class="container-fluid">
    <div class="row pb-4">
      <div class="col-md-6 d-flex justify-content-center align-items-center flex-column">
      
        <h1 class="text-center font-weight-bold" >
          Tá precisando desapegar?</h1>
          <p class="fs-25">Então <b id="repassa">repassa</b>!</p>
          <div class="row"> <button class="mt-5 btn btn-lg mr-3" routerLink='/sobre'>Sobre nós</button>
            <button class="mt-5 btn btn-lg" routerLink="/cadastrar">Cadastre-se</button>

        </div>
       
      </div>
      <!--carrossel-->
      <div class="col-md-6 d-flex justify-content-center">
        <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img class="d-block w-100" src="https://i.imgur.com/gxrJ95w.png" alt="Primeiro Slide">
              </div>
              <div class="carousel-item">
                <img class="d-block w-100" src="https://i.imgur.com/i1ZDXhx.png" alt="Segundo Slide">
              </div>
              <div class="carousel-item">
                <img class="d-block w-100" src="https://i.imgur.com/Bdbflys.png" alt="Terceiro Slide">
              </div>
            </div>
          </div>
      <!--carrossel-->
    </div>
    </div>

    <div class="row pt-5 pb-5 d-flex justify-content-center">
        <div class="row">
            <div class="col-md-6">
                <img
                  src="https://i.imgur.com/5KOEUob.png"
                  alt=""
                  width="400px"
                  height="400px"
                />
              </div>  
        </div>

      <div class="col-md-6 d-flex justify-content-center flex-column">
            <div class="row d-flex justify-content-center mb-5">
                <div class="col-md-10">
                    <h2 class="mb-5 titulo" >Conheça mais</h2>
                    <p class="quemSomos-font">
                        Somos uma rede social criada com o propósito de dar novos significados a itens seminovos, como móveis, eletrodomésticos e roupas. Nosso objetivo é conectar pessoas que estão buscando por doações à pessoas procurando se desapegar de itens que não utilizam mais. 
                    </p>
                    <p class="quemSomos-font">A repassa também promove um espaço para divulgar campanhas de assistência social idealizadas para comunidades como por exemplo: Campanha do agasalho.
                    </p>
                    <div class="row d-flex justify-content-center">
                        <button class="btn btn-lg" routerLink='/sobre'>Sobre nós</button>
                    </div>
                </div>
            </div> 
          </div>

      <!--cards-->
      <div class="row d-flex justify-content-center mt-5">
        <div class="col-md-10">
          <h2 class="mb-5 titulo">Como funciona?</h2>
          <div class="card-deck">
            <div class="card">
              <img class="card-img-top" src="https://i.imgur.com/J6AwmdW.png" alt="Imagem de capa do card">
              <div class="card-body">
                <h4 class="card-title text-center font-weight-bold" id="repassa">Preciso desapegar...</h4>
                <p class="card-text">Tem roupas, móveis ou eletrodomésticos que não utiliza mais? </p>
                <p>A repassa te ajuda a encontrar um novo lar para seus itens!</p>
                <p>Você desapega, ajuda quem precisa e colabora para diminuir o impacto ambiental que o descarte desses itens poderiam gerar.</p>
              </div>
            </div>
            <div class="card">
              <img class="card-img-top" src="https://i.imgur.com/O8m0Lch.png" alt="Imagem de capa do card">
              <div class="card-body">
                <h4 class="card-title text-center font-weight-bold" id="repassa">Estou precisando de...</h4>
                <p class="card-text">Está precisando de roupas de frio ou uma cadeira para o seu home office?</p>
                <p>A repassa te ajuda a encontrar os itens perfeitos pra você!</p>
                <p>É só se cadastrar e começar as suas buscas.</p>   
              </div>
            </div>
            <div class="card">
              <img class="card-img-top" src="https://i.imgur.com/yRTjKUk.png" alt="Imagem de capa do card">
              <div class="card-body">
                <h4 class="card-title text-center font-weight-bold" id="repassa">Quero divulgar campanhas</h4>
                <p class="card-text">Viu uma campanha de solidariedade bacana acontecendo?</p>
                <p>A repassa é o lugar certo para divulgar!</p>
                <p>Vamos juntes expandir ainda mais essa rede do bem!</p>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center"> <button class="mt-5 btn btn-lg mr-3" routerLink='/sobre'>Sobre nós</button>
              <button class="mt-5 btn btn-lg" routerLink="/cadastrar">Cadastre-se</button>
        </div>
        </div>
      </div>
      <!--cards-->

    </div>
    
</div>


<app-rodape></app-rodape>

